<template>
    <div>
        <va-card>
            Perfil
        </va-card>
    </div>
</template>

<script>
export default {
    data () {
        return {

        }
    }
}
</script>

<style scoped>

</style>